<template>
  <div class="plan-selector">
    <div class="row mb-5 text-center">
      <div class="col-md-8 mx-auto">
        <div class="card bs">
          <div class="card-body">
            <div class="row feature-blocks">
              <div class="col-sm-3 col-6">
                <IconBuoy height="35" class="mb-2" />
                <p class="small-12 mb-0">24x7 Support</p>
              </div>
              <div class="col-sm-3 col-6">
                <IconSwatch height="35" class="mb-2" />
                <p class="small-12 mb-0">100% Customizable</p>
              </div>
              <div class="col-sm-3 col-6">
                <IconRefresh height="35" class="mb-2" />
                <p class="small-12 mb-0">Automatic Updates</p>
              </div>
              <div class="col-sm-3 col-6">
                <IconSecurityCheck height="35" class="mb-2" />
                <p class="small-12 mb-0">Secure &amp; Optimized</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-5" v-if="isAffiliateOrShopifyStaff">
      <DevelopmentStore v-if="plan === 'affiliate'" setup />
      <ShopifyStaffStore v-else setup />
      <div class="mt-5 text-center" v-if="setup">
        <button class="btn btn-primary" @click="select('affiliate')">
          Continue with {{plan | upperFirst}} plan
        </button>
      </div>
      <hr class="mt-5">
    </div>
    <div class="row mb-5 text-center" v-if="!isAffiliateOrShopifyStaff && eligibleForTrial">
      <div class="col-md-8 mx-auto">
        <Alert class="alert-attention mb-2" icon="IconBolt" title="Pro plan">
          <p class="mb-0">As an introductory offer, get our best plan free for <span class="em-line">15 days!</span></p>
        </Alert>
        <p class="mb-0 small text-muted">Basic &amp; Pro plans start with a 15-day free trial. You can cancel it or downgrade to free plan anytime.</p>
      </div>
    </div>
    <div class="container">
      <div class="row mb-4">
        <div class="col-md-4 card bs free-plan">
          <div class="card-body">
            <h2 class="lead">Free<IconCheck class="active" v-if="plan === 'free'" height="20" /></h2>
            <h3 class="mb-3">$0 <small>/ m</small></h3>
            <SaveButton
              :hasChanged="true"
              :saveText="buttonText('free')"
              @click="select('free')"
              class="mb-3"
              v-if="plan !== 'free' && !isAffiliateOrShopifyStaff"/>
            <ul class="list-unstyled mb-0 font-weight-normal">
              <li>This plan includes;</li>
              <li>
                <div class="media text-left">
                  <IconCheck height="20" class="mr-2" />
                  <div class="media-body">
                    <p>Compliant with GDPR</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="media text-left">
                  <IconCheck height="20" class="mr-2" />
                  <div class="media-body">
                    <p>AMP for Products</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="media text-left">
                  <IconCheck height="20" class="mr-2" />
                  <div class="media-body">
                    <p>Shopify Analytics, Google Analytics &amp; Facebook Analytics</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="media text-left">
                  <IconCheck height="20" class="mr-2" />
                  <div class="media-body">
                    <p>Integration with Shopify Product Reviews</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-8 super-plan-container">
          <div class="row bs super-plan-row">
            <div class="col-md-6 card">
              <div class="card-body">
                <h2 class="lead">Basic<IconCheck class="active" v-if="plan === 'basic'" height="20" /></h2>
                <h3 class="mb-3">$9 <small>/ m</small></h3>
                <SaveButton
                  :hasChanged="true"
                  :saveText="buttonText('basic')"
                  @click="select('basic')"
                  class="mb-3"
                  v-if="plan !== 'basic' && !isAffiliateOrShopifyStaff"/>
                <ul class="list-unstyled mb-0 font-weight-normal">
                  <li>Everything in Free, and;</li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>AMP for Collections</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Announcement &amp; Quick Buy</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>WhatsApp, Tidio &amp; Tawk Floating Buttons</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Google Tag Manager</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Product Suggestions</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Error Monitoring <sup>beta</sup></p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Integration with Judge.me, Loox, Ryviu, Stamped, Ali Reviews, Yotpo, Growave &amp; Product Reviews with Photos by HulkApps</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6 card">
              <div class="card-body">
                <h2 class="lead">Pro<IconCheck class="active" v-if="plan === 'pro'" height="20" /></h2>
                <h3 class="mb-3">$19 <small>/ m</small></h3>
                <SaveButton
                  :hasChanged="true"
                  :saveText="buttonText('pro')"
                  @click="select('pro')"
                  class="mb-3"
                  v-if="plan !== 'pro' && !isAffiliateOrShopifyStaff"/>
                <ul class="list-unstyled mb-0 font-weight-normal">
                  <li>Everything in Basic, and;</li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>AMP for Blog posts</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Related Articles</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Custom CSS</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Integration with Disqus</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Sitemap</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Preload Product Suggestions</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Precaching with App Shell</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="media text-left">
                      <IconCheck height="20" class="mr-2" />
                      <div class="media-body">
                        <p>Removable "AMP &mdash; Powered by Superchargify" footer</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 card bs mx-auto plus-plan">
          <div class="card-body">
            <h2 class="lead">Plus<IconCheck class="active" v-if="plan === 'plus'" height="20" /></h2>
            <h3 class="mb-3">$49 <small>/ m</small></h3>
            <SaveButton
              :hasChanged="true"
              :saveText="buttonText('plus')"
              @click="select('plus')"
              class="mb-3"
              v-if="plan !== 'plus' && !isAffiliateOrShopifyStaff"/>
            <ul class="list-unstyled mb-0 font-weight-normal">
              <li>Everything in Pro, and;</li>
              <li>
                <div class="media text-left">
                  <IconCheck height="20" class="mr-2" />
                  <div class="media-body">
                    <p>Custom Analytics</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="media text-left">
                  <IconCheck height="20" class="mr-2" />
                  <div class="media-body">
                    <p>Priority Support</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import filters from '@/mixins/filters'

import DevelopmentStore from './DevelopmentStore'
import ShopifyStaffStore from './ShopifyStaffStore'

import '@/assets/scss/_plan.scss'

export default {
  mixins: [
    filters
  ],
  props: {
    setup: Boolean
  },
  components: {
    DevelopmentStore,
    ShopifyStaffStore
  },
  computed: {
    ...mapState([ 'eligibleForTrial', 'plan' ]),
    isAffiliateOrShopifyStaff: function () {
      return this.plan === 'shopify_staff' || this.plan === 'affiliate'
    }
  },
  methods: {
    ...mapActions([ 'savePlan' ]),
    select: function (plan) {
      if (plan === 'affiliate') {
        this.$store.commit('NEXT_STEP')

        this.$router.replace({
          name: 'setup_done',
          query: {
            plan,
            subscription: 'success'
          }
        })

        return
      }

      this.savePlan(plan)
    },
    buttonText: function (plan) {
      if (this.plan === plan ||
          !this.eligibleForTrial ||
          plan === 'free') {
        if (this.setup) {
          return 'Continue'
        }

        return 'Select'
      }

      return 'Start 15-day free trial'
    }
  }
}
</script>
